import { PublicRegistry } from 'services/organization/organization.interface';

export class PublicRegistryFilters {
  search = '';
  order_id = 'last_name';
  order_type = 'asc';
  page = 1;
  page_size = 20;
  filters = {
    last_name: [],
    certificationIds: [],
    parentVersionIds: [],
    acronyms: [],
    organizationId: null,
  };
}

export function mapRegistries(arr: PublicRegistry.RegistryEntry[], isDesktop: boolean) {
  return arr.map(({ rows: regRows, ...otherParams }) => {
    const hideColumnsObj: any = regRows.reduce((obj, row) => (obj[row.sort_id] = { value: !isDesktop }) && obj, {});
    if (!isDesktop) {
      let needNameColumn = true;
      ['first_name', 'last_name'].forEach((key) => {
        if (hideColumnsObj[key]) {
          needNameColumn = false;
          hideColumnsObj[key].value = false;
        }
      });
      const { name, certification_title, acronym } = hideColumnsObj;
      if (needNameColumn && name) {
        name.value = false;
      }
      if (certification_title) {
        certification_title.value = false;
      } else if (acronym) {
        acronym.value = false;
      }
    }
    const rows = regRows.map((row) => {
      row.hidden = row.sort_id ? hideColumnsObj[row.sort_id].value : !isDesktop;
      return row;
    });
    return {
      ...otherParams,
      rows,
    };
  });
}
